// extracted by mini-css-extract-plugin
module.exports = {"icon":"contact_icon__3hVyW"};